import styled, { keyframes } from 'styled-components';
import Logo from '../../assets/icons/logo-small.svg';

const shimmer = keyframes`
  0% {
    background-position: 200% center;
  }
  100% {
    background-position: -200% center;
  }
`;

export const Loader = styled.div`
  width: ${({ $width }) => `${$width / 10 || 8}rem`};
  height: ${({ $height }) => `${$height / 10 || 8}rem`};
  background: linear-gradient(90deg, #2a2a2a 25%, #3d3d3d 50%, #2a2a2a 75%);
  background-size: 200% auto;
  mask: url(${Logo}) no-repeat center / contain;
  -webkit-mask: url(${Logo}) no-repeat center / contain;
  animation: ${shimmer} 1.6s linear infinite;
`;
